<template>
  <div class="chooseItem" id="step-1" v-if="hasModelStage">
    <div class="wrap">
      <div class="title-wrap">
        <p class="fs-36 color-black bold">
          {{ blockTitle }}
        </p>
        <button
          v-if="isCompleted"
          class="btn btn-link"
          @click="reset"
        >
          {{ trans.change }}
        </button>
      </div>

      <ul v-if="!isCompleted" class="checkbox-list">
        <li
          v-for="model in preselected.model.list"
          :key="model.id"
          :class="modelOptionClass(model)"
          class="checkboxEl"
          @click="selectModel(model)"
        >
          <div class="stripe"/>
          <p class="title w-100">{{ modelTitle(model) }}</p>
          <p class="description" v-html="model.description"></p>
          <div class="price">
            {{ trans.from }}
            <div class="d-flex items-center mt-2.5">
              <span class="mt-0 mr-1">{{ price(model) }}</span>
            </div>
          </div>
          <div class="ui-tooltip xl-offset-left">
            <button type="button" class="ui-tooltip__btn"/>
            <div class="ui-tooltip__dropdown">These prices are shown with 21% VAT as a reference. Your exact price will
              be calculated by applying the VAT corresponding to your territory in the final purchasing process.
            </div>
          </div>
        </li>
      </ul>

      <button
        v-if="!isCompleted"
        :class="confirmBtnClass"
        :disabled="isDisabled"
        class="btn btn-green ld-ext-right"
        type="button"
        @click="confirmSelected"
      >
        {{ trans.confirm }}
        <div class="ld ld-ring ld-spin"></div>
      </button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "ModelSelector",
  props: {
    trans: {
      required: true
    }
  },
  computed: {
    ...mapGetters({
      preselected: 'build/preselected',
      loading: 'build/selectorLoading',
    }),
    blockTitle() {
      if (this.isCompleted) {
        return this.preselected.model.selected.title
      }

      return this.trans['choose_your_model']
    },
    hasModelStage() {
      return this.preselected && this.preselected.model
    },
    isCompleted() {
      return this.hasModelStage && this.preselected.model.completed
    },
    isDisabled() {
      return !this.hasModelStage || this.preselected.model.selected === null || this.loading
    },
    confirmBtnClass() {
      return {
        disabled: this.isDisabled,
        running: this.loading,
      }
    },
  },
  methods: {
    modelTitle(model) {
      return model.title;
    },
    reset() {
      this.$store.commit('build/setSelectorLoading', true)

      let preselected = {...this.preselected}
      preselected.model.selected = null
      preselected.model.completed = false
      preselected.model.active = true
      preselected.title.active = false
      preselected.title.completed = false
      // preselected.brakes.active = false
      // preselected.brakes.completed = false
      preselected.color.active = false
      preselected.color.completed = false
      preselected.size.active = false
      preselected.size.completed = false

      this.$store.commit('build/setPreselected', {...this.preselected, ...preselected})


      this.$store.dispatch('build/updatePreselected').then(ps => {
        this.$store.commit('build/setSelectorLoading', false)
        this.$store.commit('build/setPreselected', {...this.preselected, ...ps})

        history.pushState({}, "", `${location.origin}/en/choose`)
      })
    },
    price(model) {
      return this.$crConverter(model.price_min, 'EUR')
    },
    isSelected(model) {
      return this.hasModelStage && this.preselected.model.selected.id === model.id
    },
    modelOptionClass(model) {
      return {
        active: this.isSelected(model)
      }
    },
    selectModel(model) {
      this.$store.commit('build/setSelectedModel', model)
    },
    confirmSelected() {
      this.$store.commit('build/setSelectorLoading', true)

      this.$store.dispatch('build/updatePreselected').then(ps => {
        this.$store.commit('build/setSelectorLoading', false)
        this.$store.commit('build/setPreselected', {...this.preselected, ...ps})

        history.pushState({}, "", `${location.origin}${window.removeTrailingSlash(location.pathname)}/${this.preselected.model.selected.slug}`)

        setTimeout(() => {
          this.$root.$emit("scrollTo", {
            from: 1,
            to: 2
          })
        }, 250)
      })

      // this.$store.dispatch('build/selectModel', {
      //   path: this.$path,
      //   model: this.selectedModel
      // }).then(() => {
      //   this.$emit('onConfirmed')
      // }).finally(() => {
      //   this.loading = false
      // })
    }
  }
}
</script>
